import { FormattedMessage } from '@99designs/common/i18n';
import { Currency, toUnit } from 'common/utils/currency';
import React from 'react';
import { FormattedNumber } from 'react-intl';

export const FormattedBudget: React.FunctionComponent<{ budget: number; currency: string }> = ({
    budget,
    currency,
}) => {
    return (
        <FormattedMessage
            message={__('budget of {budget}')}
            values={{
                budget: (
                    <FormattedNumber
                        value={toUnit(budget, currency as Currency)}
                        style="currency"
                        currency={currency}
                        minimumFractionDigits={0}
                    />
                ),
            }}
        />
    );
};
